import { mapGridIndexes } from '@shared/commonFunctions';
import { LocalTabContent } from '@styles/CommonStyles';
import { ILenderUtilityTabProps } from '../LenderUtilityTabs';
import { DocFeesAdditionalTable } from './DealFeesTable/DocFeesAdditionalTable';
import { DocFeesTable } from './DocFeesTable/DocFeesTable';

export const DocFees = ({ data, lenderId }: ILenderUtilityTabProps) => {
  const docFeeStateExclusions = data?.docFeeStateExclusions;
  const dealFees = data?.dealFees;

  return (
    <LocalTabContent>
      <DocFeesTable lenderId={lenderId} data={mapGridIndexes(docFeeStateExclusions)} includeTitleFeeInDeal={data?.includeTitleFeeInDeal ?? false} />

      <DocFeesAdditionalTable lenderId={lenderId} data={mapGridIndexes(dealFees)} />
    </LocalTabContent>
  );
};
